import React from 'react';
import { ConductRequestsListContainer } from '../../containers';

const ConductRequestsListPage = () => <ConductRequestsListContainer />;

export default ConductRequestsListPage;
